module.exports = {"630104001":"西关大街街道","630104002":"古城台街道","630104003":"虎台街道","630104004":"胜利路街道","630104005":"兴海路街道","630104006":"文汇路街道","630104007":"通海路街道","630104100":"彭家寨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630104.json
// module id = 2981
// module chunks = 0